import _ from 'lodash';

import {
  JiraTicketStatus,
  QueryJiraTicketsFilterInput,
  useCurrentDevelopmentWorkWidgetLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import { DateTime } from 'luxon';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface ITicket {
  id: string;
  key: string;
  title: string;
  createdAt: DateTime;
  status: JiraTicketStatus;
}

export interface IData {
  tickets: ITicket[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useCurrentDevelopmentWorkWidgetLazyQuery,
    genFilter2GqlFilter: () => __filter2GqlFilter,
    defaultFilterArgs: {},
    clientColumn2GqlSortField: {},
    gqlResultData2GqlPageInfo: gqlResultData =>
      gqlResultData?.jiraTickets.pageInfo,

    gqlResultData2TupleData: (gqlTuple): IData => {
      return {
        tickets: _.map(gqlTuple.data?.jiraTickets.nodes ?? [], (d): ITicket => ({
          id: d.id,
          key: d.key,
          createdAt: DateTime.fromISO(d.createdAt),
          title: d.title,
          status: d.status
        }))
      };
    }
  });
}



function __filter2GqlFilter(): QueryJiraTicketsFilterInput {
  return {};
}
